'use client';

import { useSession } from 'next-auth/react';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

export const useAuth = () => {
  const { data: session, status } = useSession();
  const router = useRouter();

  const checkAuth = useCallback(
    (redirectTo?: string) => {
      if (status === 'loading') return false;
      if (redirectTo && status === 'unauthenticated') {
        router.replace(redirectTo);
        return false;
      }
      return status === 'authenticated';
    },
    [status, router]
  );

  return {
    session,
    status,
    isAuthenticated: status === 'authenticated',
    isLoading: status === 'loading',
    user: session?.user,
    checkAuth,
  };
};
